import { ImportedBaseAvailability } from "@/app/types/imported-profile/ImportedBaseSearch";
import { ImportedProfileListTab } from "@/app/types/imported-profile/ImportedProfileListTab";
import ProspectSourceLinkedin from "./ProspectSourceLinkedin";
import styles from "./ProspectSources.module.css";

type Props = {
  lang: string;
  isPlaceholder?: boolean;
  isLoading?: boolean;
  isSearching?: boolean;
  linkedinCount?: number;
  linkedinPotentialCount?: number;
  linkedinFoundCount?: number;
  linkedinRejectedCount?: number;
  importedBase?: ImportedBaseAvailability;
  importedBaseRunning?: boolean;
  onOpenImportedBase?: () => void;
  linkedinCanAnalyze?: boolean;
  linkedinPending?: boolean;
  canRun?: boolean;
  onLinkedinAnalyze?: () => void;
  onLinkedinViewImportedProfiles?: (tab?: ImportedProfileListTab) => void;
  onViewFound?: () => void;
};

export default function ProspectSources(props: Props) {
  const {
    lang,
    isPlaceholder = false,
    isLoading = false,
    linkedinCount = 0,
    linkedinPotentialCount = 0,
    linkedinFoundCount = 0,
    linkedinRejectedCount = 0,
    importedBase,
    importedBaseRunning,
    onOpenImportedBase,
    linkedinCanAnalyze = true,
    linkedinPending = false,
    canRun = true,
    onLinkedinAnalyze,
    onLinkedinViewImportedProfiles,
    onViewFound,
  } = props;

  return (
    <div className={styles.grid}>
      <ProspectSourceLinkedin
        lang={lang}
        isPlaceholder={isPlaceholder}
        isLoading={isLoading}
        count={linkedinCount}
        potentialCount={linkedinPotentialCount}
        foundCount={linkedinFoundCount}
        rejectedCount={linkedinRejectedCount}
        importedBase={importedBase}
        importedBaseRunning={importedBaseRunning}
        onOpenImportedBase={onOpenImportedBase}
        canAnalyze={linkedinCanAnalyze}
        canRun={canRun}
        isAnalyzing={linkedinPending}
        onAnalyze={onLinkedinAnalyze}
        onViewImportedProfiles={onLinkedinViewImportedProfiles}
        onViewFound={onViewFound}
      />
    </div>
  );
}
